import { createReducer } from '@reduxjs/toolkit';
import { getCareerPage, sendCareerCv } from '../actions/careerPage';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getCareerPage.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  })).addCase(sendCareerCv.fulfilled, (state, action) => {
    console.log(action);
  });
});
